_ = require 'underscore'
t = require('app/scripts/views/internal/teacup-with-helpers')('org_prefs_nonorg_invites')
{ BoardInviteRestrictValues } = require 'app/scripts/views/organization/constants'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = t.renderable (data) ->
  { enterprise, boardInviteRestrict } = data
  enterpriseName = enterprise?.displayName
  showManagedOption = enterprise?.hasClaimedDomains

  t.div { style: 'margin: 12px 0 0;' }, ->

    t.p ->
      t.format 'who-can-be-added-to-team-boards'

    t.ul '.pop-over-list.checkable.inline-check', ->
      t.li { class: t.classify('active': boardInviteRestrict == BoardInviteRestrictValues.ANY) }, ->
        t.a
          href: '#',
          'data-restriction': BoardInviteRestrictValues.ANY,
          class: t.classify('js-change-board-invite-restrict': boardInviteRestrict != BoardInviteRestrictValues.ANY)
        , ->
          t.format 'anybody'
          t.span { class: 'sub-name' }, ->
            t.format 'anybody-description'

      t.li { class: t.classify('active': boardInviteRestrict == BoardInviteRestrictValues.ORG) }, ->
        t.a
          href: '#',
          'data-restriction': BoardInviteRestrictValues.ORG,
          class: t.classify('js-change-board-invite-restrict': boardInviteRestrict != BoardInviteRestrictValues.ORG)
        , ->
          t.format 'only-team-members'
          t.span { class: 'sub-name' }, ->
            t.format 'only-team-members-description'

      if showManagedOption
        t.li { class: t.classify('active': boardInviteRestrict == BoardInviteRestrictValues.MANAGED) }, ->
          t.a
            href: '#',
            'data-restriction': BoardInviteRestrictValues.MANAGED,
            class: t.classify('js-change-board-invite-restrict': boardInviteRestrict != BoardInviteRestrictValues.MANAGED)
          , ->
            t.format 'only-managed-members'
            t.span { class: 'sub-name' }, ->
              t.format 'only-managed-members-description', { enterpriseName }

        t.li { class: t.classify('active': boardInviteRestrict == BoardInviteRestrictValues.ORG_OR_MANAGED) }, ->
          t.a
            href: '#',
            'data-restriction': BoardInviteRestrictValues.ORG_OR_MANAGED,
            class: t.classify('js-change-board-invite-restrict': boardInviteRestrict != BoardInviteRestrictValues.ORG_OR_MANAGED)
          , ->
            t.format 'team-members-and-managed-members'
            t.span { class: 'sub-name' }, ->
              t.format 'team-members-and-managed-members-description', { enterpriseName }
